import { highlightMatch } from './search';
import { sanitizeHandbookTitleHighlightHtml } from './richComment';

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Safe HTML for policy title column when search is active (only `<mark>` allowed). */
export function handbookTitleSearchHighlight(title: string, query: string): string {
  const trimmed = query.trim();
  if (!trimmed) return escapeHtml(title);
  return sanitizeHandbookTitleHighlightHtml(highlightMatch(escapeHtml(title), trimmed));
}
